import { ChangeSet } from '@api/models/common/ChangeSet';
import { UserRole } from '@api/models/enums/UserRole';
import { hasRole } from '../../../utils/roles';
import { API_ACCESS_PATH } from '../../integration/integrationUtils';

// The roles of the `userDetail` and `integrationApiClient` routes in layout/menuItems.tsx; a link to a screen the viewer cannot open is worse than none.
const USER_DETAIL_ROLES = [UserRole.AdminQcs, UserRole.AdminCompany, UserRole.ManagerOsah];
const INTEGRATION_ROLES = [UserRole.AdminQcs, UserRole.AdminCompany];

/**
 * Where to send a viewer who clicks the author of a change: the user's detail, or the keys of the API client that made it.
 * Undefined when there is no such screen for this change (a system change) or the viewer has no access to it.
 */
export const getChangeActorPath = (
  change: Pick<ChangeSet, 'by' | 'byApiClient'>,
  roles: UserRole[] | undefined,
  getUserDetailPath: (userId: string) => string,
): string | undefined => {
  if (!change.by?.id) return undefined;
  if (change.byApiClient) {
    return hasRole(roles, INTEGRATION_ROLES) ? `${API_ACCESS_PATH}/${change.by.id}/keys` : undefined;
  }
  return hasRole(roles, USER_DETAIL_ROLES) ? getUserDetailPath(change.by.id) : undefined;
};
